export default "__VITE_ASSET__Bpt01NFP__"